import type {
	Abi,
	Address,
	ContractName,
	ValidChainId,
} from "@bracket/chainography/types";

import { chains } from "..";

export const getContractAddress = <C extends ValidChainId = 1>(
	contract: ContractName<C>,
	chainId: ValidChainId = 1,
): Address => {
	try {
		if (chainId in chains) {
			if (contract in chains[chainId].contracts) {
				const { address, } = chains[chainId as number].contracts[contract];
				return address;
			}
			throw new Error(`contract "${contract.toString()}" does not exist on chain ${chainId}`);
		}
		throw new Error(`received invalid chainId ${chainId}`);
	}
	catch( err ) {
		throw new Error(`@bracket/chainography::getContractAddress failed - ${err.message}`)
	}
};
